import { requeueEmail } from "../../../../../actions/Utilities/EmailLogs";
import { useMutation } from "react-query";
const useRequeueEmail = () => {
  return useMutation(requeueEmail);
};
export default useRequeueEmail;
